/**
 *  群发弹出框
 *
 */
'use strict';
angular.module('weixinMassSendModule', []).controller('weixinMassSendController', ['$scope', 'draftParams', '$modalInstance', 'trsHttpService', '$q', 'modalDialog', 'trsspliceString', 'wechatBtnService',
    function($scope, draftParams, $modalInstance, trsHttpService, $q, modalDialog, trsspliceString, wechatBtnService) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                massArray: draftParams.items,
                type: draftParams.type,
                sendTo: '全部',
                remarks: '直接群发存在风险，建议先预览，确认无误后在“已预览”中群发稿件',
                picWordId: draftParams.picWordId,
            };
            $scope.status = {
                isSort: false,
                isFirstClick: false,
            };
        }

        /**
         * [initData description]
         * @return {[type]} [description]
         */
        function initData() {
            if (draftParams.type == 'detail') {
                findDocDetails($scope.data.massArray).then(function() {
                    queryCoverPic();
                });

            }
            if ($scope.data.type != 'detail') {
                queryCoverPic();
            }

        }

        /**
         * [getTopUrl description] 取得封面图
         * @param  {[type]} item [description]
         * @return {[type]}       [description]
         */
        $scope.getTopUrl = function(item) {
            if (item.CoverPic) {
                return item.CoverPic.TOPSRCPICURL ? item.CoverPic.TOPSRCPICURL : item.CoverPic.SRCPICURL;
            } else {
                return '';
            }
        };

        /**
         * [findDocDetails description]群发历史获取稿件详情
         * @param  {[type]} items [description]
         * @return {[type]}       [description]
         */
        function findDocDetails(items) {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'findDocDetails',
                DocIds: items.SENDINGORDER,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.massArray = data;
                deferred.resolve($scope.data.massArray);
            });
            return deferred.promise;
        }

        /**
         * [queryCoverPic description]获取封面图
         * @return {[type]} [description]
         */
        function queryCoverPic() {

            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'queryCoverPic',
                DocIds: trsspliceString.spliceString($scope.data.massArray, 'METADATAID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < $scope.data.massArray.length; i++) {
                    for (var j = 0; j < data.length; j++) {
                        if ($scope.data.massArray[i].METADATAID == data[j].DOCID) {
                            $scope.data.massArray[i].CoverPic = data[j];
                        }
                    }
                }
            });
        }

        /**
         * [sort description]排序
         * @return {[type]} [description]
         */
        $scope.sort = function() {
            $scope.status.isSort = true;
        };

        /**
         * [return description]排序返回
         * @return {[type]} [description]
         */
        $scope.return = function() {
            $scope.status.isSort = false;
        };

        /**
         * [changeSort description]移动方法
         * @param  {[type]} flag  [description]
         * @param  {[type]} index [description]
         * @return {[type]}       [description]
         */
        $scope.changeSort = function(flag, index) {
            var indexItem;
            if (flag == 'down') {
                indexItem = $scope.data.massArray[index];
                $scope.data.massArray[index] = $scope.data.massArray[index + 1];
                $scope.data.massArray[index + 1] = indexItem;
            } else {
                indexItem = $scope.data.massArray[index];
                $scope.data.massArray[index] = $scope.data.massArray[index - 1];
                $scope.data.massArray[index - 1] = indexItem;
            }
        };

        /**
         * [confirm description] 提交
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            if ($scope.data.type != 'detail') {
                $scope.status.isFirstClick = true;
                $modalInstance.dismiss();
                secondConfirm();
            } else {
                $scope.status.isFirstClick = false;
                $modalInstance.dismiss();
            }

        };

        /**
         * [secondConfirm description] 取消
         * @return {[type]} [description]
         */
        function secondConfirm() {
            modalDialog.confirmModal('群发', '稿件群发后将无法撤销，如需修改与删除只能前往微信公众平台官方后台，是否确认稿件无误并继续群发？', function() {
                var params = {
                    serviceid: 'mlf_wechatgroupsend',
                    methodname: 'groupSend',
                    DocIds: '',
                };
                var arr = [];
                for (var i = 0; i < $scope.data.massArray.length; i++) {
                    arr.push($scope.data.massArray[i].METADATAID);
                }
                params.DocIds = arr.join();
                if ($scope.data.picWordId) { // 已预览下的群发弹框确认请求要加上这个id
                    params.WechatCardMessageId = $scope.data.picWordId;
                    params.methodname = 'previewCardSend';
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', 'forbiden')
                    .then(function(data) {
                        modalDialog.alertType('群发任务进行中，请耐心等待', '', 'info', false, function() {
                            $scope.status.isFirstClick = false;
                            $modalInstance.close('success');
                        });
                    }, function(err) {
                        $scope.status.isFirstClick = false;
                        $modalInstance.close('success');
                        if (err.ISSUCCESS === 'false') {
                            wechatBtnService.wxPreviewSuccess(function() {
                            }, err, false);
                        }
                        if (err.status === '-1') {
                            modalDialog.alertType('', err.reason, 'warning', 'confirm', function() {
                            });
                        }
                    });
            }, function() {
                wechatBtnService.massSend($scope.data.massArray, $scope.data.type, function() {
                });
            });
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $scope.status.isFirstClick = false;
            $modalInstance.dismiss();
        };
    },
]);
